import { Button, Checkbox, Form, Modal } from "antd";
import React, { useState } from "react";

interface ConsentCheckboxFieldProps {
  name: "terms_agreed" | "privacy_agreed";
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  linkLabel: string;
  requiredMessage: string;
  modalTitle: string;
  modalContent?: React.ReactNode;
  style?: React.CSSProperties;
}

const ConsentCheckboxField = ({
  name,
  checked,
  onCheckedChange,
  linkLabel,
  requiredMessage,
  modalTitle,
  modalContent,
  style,
}: ConsentCheckboxFieldProps) => {
  const [open, setOpen] = useState(false);

  const onAgree = () => {
    onCheckedChange(true);
    setOpen(false);
  };

  const onDecline = () => {
    onCheckedChange(false);
    setOpen(false);
  };

  return (
    <>
      <Form.Item
        label=""
        name={name}
        validateTrigger={["onSubmit"]}
        style={style}
        rules={[
          {
            validator: (_, value) => {
              if (value === true || checked === true) return Promise.resolve();
              return Promise.reject(new Error(requiredMessage));
            },
          },
        ]}
      >
        <Checkbox
          checked={checked}
          onChange={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpen(true);
          }}
        >
          By proceeding, I acknowledge that I have read and agreed to this{" "}
          <span style={{ color: "#dc1a22", textDecoration: "underline", fontWeight: 500 }}>{linkLabel}</span>
        </Checkbox>
      </Form.Item>

      <Modal
        title={modalTitle}
        open={open}
        onCancel={() => setOpen(false)}
        footer={[
          <Button key="decline" onClick={onDecline}>Decline</Button>,
          <Button key="agree" type="primary" onClick={onAgree}>Agree</Button>,
        ]}
        centered
        width={1000}
      >
        {modalContent}
      </Modal>
    </>
  );
};

export default ConsentCheckboxField;
